import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../styles/productcard.css";
import Constant from "../../helper/Constant";
import { buildProductDetailsPath } from "../../helper/productUrl";

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  console.log(product);

  const {
    _id,
    link,
    image = product.images && product.images.length > 0
      ? Constant.imageDomain + product.images[0]
      : "",
    name,
    offer_price,
    price,
    discount,
    saveAmount,
    highlight,
  } = product;
  const variants = product.variants || product.variant || [];

  const uniqueColourVariants = variants.reduce((list, variant) => {
    if (!variant.colour) return list;

    const hasColour = list.some((item) => item.colour === variant.colour);

    return hasColour ? list : [...list, variant];
  }, []);

  const handleVariantClick = (event, variant) => {
    event.preventDefault();
    event.stopPropagation();

    navigate(buildProductDetailsPath(product, variant));
  };

  return (
    <Link
      to={link || buildProductDetailsPath(product)}
      className="product-card-link"
    >
      <div className={`product-card ${highlight ? "highlight" : ""}`}>
        {offer_price > 0 && (
          <div className="discount-badge">
            {Math.round(((price - offer_price) / price) * 100)}% OFF
          </div>
        )}

        <div className="product-image-wrapper">
          <img src={image} alt={name} />
        </div>

        <div className="product-details">
          <div className="product-summary">
            <h4 className="product-title">{name}</h4>

            <div className="price-row">
              <span className="price">₹{offer_price}</span>
              <span className="mrp">₹{price}</span>
            </div>

            <div className="save-text">Save ₹{price - offer_price}</div>
          </div>

          {uniqueColourVariants.length > 0 ? (
            <div className="product-variants-panel">
              {uniqueColourVariants.slice(0, 4).map((variant, index) => (
                <span
                  key={`${variant._id || variant.colour}-${index}`}
                  className="product-variant-chip"
                  role="button"
                  tabIndex={0}
                  onClick={(event) => handleVariantClick(event, variant)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      handleVariantClick(event, variant);
                    }
                  }}
                >
                  {variant.colour}
                </span>
              ))}
              {uniqueColourVariants.length > 4 ? (
                <span className="product-variant-chip">
                  +{uniqueColourVariants.length - 4}
                </span>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    </Link>
  );
};

// const ProductCard = ({ product }) => {
//   const {
//     _id,
//     name,
//     offer_price,
//     price,
//     highlight,
//     variant = [],
//   } = product;

//   // Get lowest variant price
//   const lowestPrice =
//   variant.length > 0
//     ? Math.min(...variant.map((v) => Number(v.price || 0)))
//     : price || 0;

//   // Only consider valid offer_price (> 0)
//   const validOffers = variant
//     .map((v) => Number(v.offer_price))
//     .filter((v) => v > 0);

//   const lowestOfferPrice =
//     validOffers.length > 0
//       ? Math.min(...validOffers)
//       : 0;

//   // Final display price
//   const finalPrice = lowestOfferPrice > 0 ? lowestOfferPrice : lowestPrice;

//   // Discount
//   const discount =
//     lowestOfferPrice > 0
//       ? Math.round(((lowestPrice - lowestOfferPrice) / lowestPrice) * 100)
//       : 0;

//   const image =
//     product.images && product.images.length > 0
//       ? Constant.imageDomain + product.images[0]
//       : "";

//   return (
//     <Link to={`/product-details/${_id}`} className="product-card-link">
//       <div className={`product-card ${highlight ? "highlight" : ""}`}>

//         {discount > 0 && (
//           <div className="discount-badge">
//             {discount}% OFF
//           </div>
//         )}

//         <div className="product-image-wrapper">
//           <img src={image} alt={name} />
//         </div>

//         <div className="product-details">
//           <h4 className="product-title">{name}</h4>

//           <div className="price-row">
//             {/* Show final price */}
//             <span className="price">₹{finalPrice}</span>

//             {/* Show original only if discount exists */}
//             {lowestOfferPrice > 0 && (
//               <span className="mrp">₹{lowestPrice}</span>
//             )}
//           </div>

//           {lowestOfferPrice > 0 && (
//             <div className="save-text">
//               Save ₹{lowestPrice - lowestOfferPrice}
//             </div>
//           )}

//         </div>
//       </div>
//     </Link>
//   );
// };

export default ProductCard;
